module.exports = __webpack_public_path__ + "img/116.4.87f8aec3.png";